export const logRocketId = process.env.LOG_ROCKET_ID;
export const deployTag = process.env.DEPLOY_TAG;
// Any value counts as on — the timer is a debugging aid, not a product feature.
export const showTokenRenewalTimer = process.env.SHOW_TOKEN_RENEWAL_TIMER;
export const trustedDocumentOrigins = [
  'https://localhost:3000',
  'https://app-staging.diffinder.se',
  'https://audit.diffinder.se',
];
